import { FirstStep } from "../components/first-step";
import locale from "@bonliva-crm/locale";
import { UseFormReturn } from "react-hook-form";
import { FirstFormValues, SecondFormValues, ThirdFormValues } from "./form-values";
import { SecondStep } from "../components/second-step";
import { ThirdStep } from "../components/third-step";
import { Button, Tooltip } from "@material-ui/core";
import { GeneratePresentationAttachmentError } from "@bonliva-crm/graphql";

export enum Steps {
  First = "First",
  Second = "Second",
  Third = "Third"
}

type Props = {
  consultantId: string;
  onClose?: () => void;
  setCurrentStep: (step: Steps) => void;
  stepInput: {
    first: {
      form: UseFormReturn<FirstFormValues, any, FirstFormValues>;
      attachmentErrors: GeneratePresentationAttachmentError[];
      onSubmit: () => void;
    };
    second: {
      form: UseFormReturn<SecondFormValues, any, SecondFormValues>;
      presentationUrl: string | null;
    };
    third: {
      form: UseFormReturn<ThirdFormValues, any, ThirdFormValues>;
      onSubmit: () => void;
    };
  };
};

export type StepData = Record<
  Steps,
  { leftCta: React.ReactNode; rightCta: React.ReactNode; component: React.ReactNode }
>;

export const createStepData = (props: Props): StepData => {
  const cancelButton = (
    <Button
      variant="outlined"
      color="primary"
      onClick={() => props.onClose && props.onClose()}
    >
      {locale.Cancel}
    </Button>
  );

  const stepData: StepData = {
    [Steps.First]: {
      leftCta: cancelButton,
      rightCta: (
        <Tooltip
          title={
            props.stepInput.first.attachmentErrors.length > 0
              ? locale.AttachmentsCorrupted
              : ""
          }
        >
          <span>
            <Button
              variant="contained"
              color="primary"
              onClick={() => props.stepInput.first.onSubmit()}
              disabled={
                !props.stepInput.first.form.formState.isValid ||
                props.stepInput.first.form.formState.isSubmitting ||
                props.stepInput.first.attachmentErrors.length > 0
              }
            >
              {locale.sendPresentationSteps.first}
            </Button>
          </span>
        </Tooltip>
      ),
      component: (
        <FirstStep consultantId={props.consultantId} {...props.stepInput.first} />
      )
    },
    [Steps.Second]: {
      leftCta: cancelButton,
      rightCta: (
        <>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => props.setCurrentStep(Steps.First)}
          >
            {locale.previous}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.setCurrentStep(Steps.Third)}
            disabled={
              !props.stepInput.second.form.formState.isValid ||
              props.stepInput.second.form.formState.isSubmitting
            }
          >
            {locale.sendPresentationSteps.second}
          </Button>
        </>
      ),
      component: <SecondStep {...props.stepInput.second} />
    },
    [Steps.Third]: {
      leftCta: cancelButton,
      rightCta: (
        <>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              props.stepInput.second.form.reset();
              props.setCurrentStep(Steps.Second);
            }}
          >
            {locale.previous}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.stepInput.third.onSubmit()}
            disabled={
              !props.stepInput.third.form.formState.isValid ||
              props.stepInput.third.form.formState.isSubmitting
            }
          >
            {locale.sendPresentationSteps.third}
          </Button>
        </>
      ),
      component: <ThirdStep {...props.stepInput.third} />
    }
  };

  return stepData;
};
